;(() => {
  var e = {
      523: e => {
        !(function () {
          'use strict'
          e.exports = {
            polyfill: function () {
              var e = window,
                t = document
              if (!('scrollBehavior' in t.documentElement.style) || !0 === e.__forceSmoothScrollPolyfill__) {
                var o,
                  r = e.HTMLElement || e.Element,
                  l = 468,
                  n = { scroll: e.scroll || e.scrollTo, scrollBy: e.scrollBy, elementScroll: r.prototype.scroll || s, scrollIntoView: r.prototype.scrollIntoView },
                  i = e.performance && e.performance.now ? e.performance.now.bind(e.performance) : Date.now,
                  c = ((o = e.navigator.userAgent), new RegExp(['MSIE ', 'Trident/', 'Edge/'].join('|')).test(o) ? 1 : 0)
                ;(e.scroll = e.scrollTo =
                  function () {
                    void 0 !== arguments[0] && (!0 !== a(arguments[0]) ? h.call(e, t.body, void 0 !== arguments[0].left ? ~~arguments[0].left : e.scrollX || e.pageXOffset, void 0 !== arguments[0].top ? ~~arguments[0].top : e.scrollY || e.pageYOffset) : n.scroll.call(e, void 0 !== arguments[0].left ? arguments[0].left : 'object' != typeof arguments[0] ? arguments[0] : e.scrollX || e.pageXOffset, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : e.scrollY || e.pageYOffset))
                  }),
                  (e.scrollBy = function () {
                    void 0 !== arguments[0] && (a(arguments[0]) ? n.scrollBy.call(e, void 0 !== arguments[0].left ? arguments[0].left : 'object' != typeof arguments[0] ? arguments[0] : 0, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : 0) : h.call(e, t.body, ~~arguments[0].left + (e.scrollX || e.pageXOffset), ~~arguments[0].top + (e.scrollY || e.pageYOffset)))
                  }),
                  (r.prototype.scroll = r.prototype.scrollTo =
                    function () {
                      if (void 0 !== arguments[0])
                        if (!0 !== a(arguments[0])) {
                          var e = arguments[0].left,
                            t = arguments[0].top
                          h.call(this, this, void 0 === e ? this.scrollLeft : ~~e, void 0 === t ? this.scrollTop : ~~t)
                        } else {
                          if ('number' == typeof arguments[0] && void 0 === arguments[1]) throw new SyntaxError('Value could not be converted')
                          n.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left : 'object' != typeof arguments[0] ? ~~arguments[0] : this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top : void 0 !== arguments[1] ? ~~arguments[1] : this.scrollTop)
                        }
                    }),
                  (r.prototype.scrollBy = function () {
                    void 0 !== arguments[0] && (!0 !== a(arguments[0]) ? this.scroll({ left: ~~arguments[0].left + this.scrollLeft, top: ~~arguments[0].top + this.scrollTop, behavior: arguments[0].behavior }) : n.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop))
                  }),
                  (r.prototype.scrollIntoView = function () {
                    if (!0 !== a(arguments[0])) {
                      var o = (function (e) {
                          for (; e !== t.body && !1 === f(e); ) e = e.parentNode || e.host
                          return e
                        })(this),
                        r = o.getBoundingClientRect(),
                        l = this.getBoundingClientRect()
                      o !== t.body ? (h.call(this, o, o.scrollLeft + l.left - r.left, o.scrollTop + l.top - r.top), 'fixed' !== e.getComputedStyle(o).position && e.scrollBy({ left: r.left, top: r.top, behavior: 'smooth' })) : e.scrollBy({ left: l.left, top: l.top, behavior: 'smooth' })
                    } else n.scrollIntoView.call(this, void 0 === arguments[0] || arguments[0])
                  })
              }
              function s(e, t) {
                ;(this.scrollLeft = e), (this.scrollTop = t)
              }
              function a(e) {
                if (null === e || 'object' != typeof e || void 0 === e.behavior || 'auto' === e.behavior || 'instant' === e.behavior) return !0
                if ('object' == typeof e && 'smooth' === e.behavior) return !1
                throw new TypeError('behavior member of ScrollOptions ' + e.behavior + ' is not a valid value for enumeration ScrollBehavior.')
              }
              function d(e, t) {
                return 'Y' === t ? e.clientHeight + c < e.scrollHeight : 'X' === t ? e.clientWidth + c < e.scrollWidth : void 0
              }
              function u(t, o) {
                var r = e.getComputedStyle(t, null)['overflow' + o]
                return 'auto' === r || 'scroll' === r
              }
              function f(e) {
                var t = d(e, 'Y') && u(e, 'Y'),
                  o = d(e, 'X') && u(e, 'X')
                return t || o
              }
              function p(t) {
                var o,
                  r,
                  n,
                  c,
                  s = (i() - t.startTime) / l
                ;(c = s = s > 1 ? 1 : s), (o = 0.5 * (1 - Math.cos(Math.PI * c))), (r = t.startX + (t.x - t.startX) * o), (n = t.startY + (t.y - t.startY) * o), t.method.call(t.scrollable, r, n), (r === t.x && n === t.y) || e.requestAnimationFrame(p.bind(e, t))
              }
              function h(o, r, l) {
                var c,
                  a,
                  d,
                  u,
                  f = i()
                o === t.body ? ((c = e), (a = e.scrollX || e.pageXOffset), (d = e.scrollY || e.pageYOffset), (u = n.scroll)) : ((c = o), (a = o.scrollLeft), (d = o.scrollTop), (u = s)), p({ scrollable: c, method: u, startTime: f, startX: a, startY: d, x: r, y: l })
              }
            },
          }
        })()
      },
    },
    t = {}
  function o(r) {
    var l = t[r]
    if (void 0 !== l) return l.exports
    var n = (t[r] = { exports: {} })
    return e[r](n, n.exports, o), n.exports
  }
  ;(() => {
    'use strict'
    function e(e) {
      const t = document.querySelector(`#${e.getAttribute('aria-controls')}`)
      e.setAttribute('aria-expanded', 'false'), t.setAttribute('aria-hidden', 'true'), document.body.classList.remove('_hide-scrolling')
    }
    document.addEventListener('click', function (t) {
      var o
      t.target.closest('[data-menu-burger]') &&
        ('false' !== (o = t.target.closest('[data-menu-burger]')).getAttribute('aria-expanded')
          ? e(o)
          : (function (e) {
              const t = document.querySelector(`#${e.getAttribute('aria-controls')}`)
              e.setAttribute('aria-expanded', 'true'),
                t.setAttribute('aria-hidden', 'false'),
                (function () {
                  const e = document.body,
                    t = document.querySelector('.wrapper'),
                    o = window.innerWidth - t.offsetWidth
                  e.style.setProperty('--scroll-width', `${o}px`), e.classList.add('_hide-scrolling')
                })()
            })(o)),
        (t.target.closest('[data-scroll-to]') || t.target.closest('a')) && e(document.querySelector('[data-menu-burger]'))
    }),
      document.addEventListener('keydown', function (t) {
        if (27 === t.keyCode) {
          const t = document.querySelector('[data-menu-burger]')
          'true' === t?.getAttribute('aria-expanded') && e(t)
        }
      })
    const t = document.querySelectorAll('[data-dropdown-control]'),
      r = document.querySelectorAll('[data-dropdown]')
    let l = null,
      n = !1
    function i(e) {
      if ('mouse' !== e.pointerType || !e.target.closest('[data-hover]')) return
      const t = e.target.querySelector('[data-dropdown-control]'),
        o = e.target.closest('[data-dropdown]').querySelector('[data-dropdown-control][aria-expanded="true"]')
      ;(n = !0), l && e.target.querySelector('[data-dropdown-control][aria-expanded="true"]') ? d() : (o && (d(), a(o)), s(t))
    }
    function c(e) {
      if ('mouse' !== e.pointerType || !e.target.closest('[data-hover]')) return
      const t = e.target.querySelector('[data-dropdown-control]')
      ;(n = !1), 'false' !== t.getAttribute('aria-expanded') && (l = setTimeout(a, 600, t))
    }
    function s(e) {
      const t = document.querySelector(`#${e.getAttribute('aria-controls')}`)
      !(function (e) {
        e.style.cssText = `--max-height: ${e.scrollHeight / 16}rem`
      })(t),
        e.setAttribute('aria-expanded', !0),
        t.setAttribute('aria-hidden', !1)
    }
    function a(e) {
      const t = document.querySelector(`#${e.getAttribute('aria-controls')}`)
      e.setAttribute('aria-expanded', !1), t.setAttribute('aria-hidden', !0)
    }
    function d() {
      clearTimeout(l), (l = null)
    }
    function u(e, t) {
      t.matches ? e.setAttribute('data-hover', !0) : e.removeAttribute('data-hover')
    }
    document.addEventListener('click', function (e) {
      if (n) return
      const t = document.querySelector('[data-dropdown-control][aria-expanded="true"]')
      if (!e.target.closest('[data-dropdown-control]')) return t && !e.target.closest(`#${t.getAttribute('aria-controls')}`) ? (l && d(), void a(t)) : void 0
      !(function (e) {
        const t = e.closest('[data-dropdown]').querySelector('[data-dropdown-control][aria-expanded="true"]')
        'true' !== e.getAttribute('aria-expanded') ? (t && a(t), s(e)) : a(e)
      })(e.target.closest('[data-dropdown-control]'))
    }),
      document.addEventListener('keydown', function (e) {
        if ('Escape' === e.key) {
          const e = document.querySelector('[data-dropdown-control][aria-expanded="true"]')
          l && d(), e && a(e)
        }
      }),
      r.forEach(function (e) {
        if (!e.getAttribute('data-media-hover')) return
        const t = (function (e) {
          const t = e.dataset.mediaHover.split(', '),
            o = `(${t[0]}-width: ${+t[1] / 16}rem)`
          return window.matchMedia(o)
        })(e)
        t.addListener(() => u(e, t)), u(e, t)
      }),
      t.forEach(function (e) {
        const t = e.closest('li')
        t.addEventListener('pointerenter', i), t.addEventListener('pointerleave', c)
      })
    var f = o(523)
    function p(e) {
      e.classList.add('swiper-slide')
    }
    document.querySelectorAll('[data-scroll-to]').length > 0 &&
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-scroll-to]')) {
          const t = e.target.closest('[data-scroll-to]').dataset.scrollTo.split(', '),
            [o, r] = t,
            l = window.headerHeight,
            n = document.documentElement.scrollTop
          let i
          ;(i = 'next' === r ? document.querySelector(o).getBoundingClientRect().height - l : document.querySelector(o).getBoundingClientRect().top + n - l - 40), window.scrollTo({ top: i, behavior: 'smooth' }), e.preventDefault()
        }
      }),
      (function () {
        document.querySelectorAll('[class*="__swiper"]').forEach(e => {
          const t = (e = e.parentElement).children[0],
            o = Array.from(t.children)
          e.classList.add('swiper'), t.classList.add('swiper-wrapper'), o.forEach(p)
        })
        const e = document.querySelectorAll('.cases__slider')
        e.length > 0 &&
          e.forEach(e => {
            const t = e.querySelector('.cases__btn-slider_right'),
              o = e.querySelector('.cases__btn-slider_left')
            new Swiper(e, { direction: 'horizontal', effect: 'slide', loop: !1, speed: 1e3, spaceBetween: 24, slidesPerView: 'auto', watchOverflow: !0, navigation: { nextEl: t, prevEl: o }, keyboard: { enabled: !0 }, breakpoints: { 1100.98: { slidesPerView: 2 } } })
          }),
          document.querySelector('.reviews__slider') && new Swiper(document.querySelector('.reviews__slider'), { direction: 'horizontal', effect: 'slide', loop: !1, speed: 1e3, spaceBetween: 24, slidesPerView: 'auto', watchOverflow: !0, navigation: { nextEl: '.reviews__btn-slider_right', prevEl: '.reviews__btn-slider_left' }, keyboard: { enabled: !0 } })
      })(),
      (function () {
        const e = document.querySelector('header'),
          t = document.querySelector('body')
        if (!e) return
        window.addEventListener('scroll', l)
        let o,
          r = !1
        function l() {
          const l = document.documentElement.scrollTop
          ;(o = e.offsetHeight), l > 1 && !r ? (e.classList.contains('_fixed') && e.classList.add('_scrolled'), (o = e.offsetHeight), (r = !r)) : l <= 1 && r && (e.classList.contains('_fixed') && e.classList.remove('_scrolled'), (o = e.offsetHeight), (r = !r)), t.style.setProperty('--header-height', (o ? o / 16 : 0) + 'rem'), (window.headerHeight = e.offsetHeight)
        }
        setTimeout(() => {
          l()
        }, 100)
      })(),
      document.querySelectorAll('[role="tablist"]').forEach(e => e.addEventListener('keydown', m)),
      document.addEventListener('click', function (e) {
        e.target.closest('[role="tab"]') && g(e.target.closest('[role="tab"]'))
      })
    const h = e => 'ArrowRight' === e || 'ArrowLeft' === e || 'ArrowUp' === e || 'ArrowDown' === e || 'Home' === e || 'End' === e
    function m(e) {
      if (h(e.key)) {
        const t = e.target,
          o = t.closest('[role="tablist"]'),
          r = Array.from(o.querySelectorAll('[role="tab"]'))
        let l = r.indexOf(t)
        const n = () => (++l >= r.length ? 0 : l),
          i = () => (--l < 0 ? r.length - 1 : l)
        switch ((t.setAttribute('tabindex', -1), e.key)) {
          case 'ArrowRight':
            l = n()
            break
          case 'ArrowDown':
            e.preventDefault(), (l = n())
            break
          case 'ArrowLeft':
            l = i()
            break
          case 'ArrowUp':
            e.preventDefault(), (l = i())
            break
          case 'Home':
            e.preventDefault(), (l = 0)
            break
          case 'End':
            e.preventDefault(), (l = r.length - 1)
        }
        const c = r[l]
        c.setAttribute('tabindex', 0), c.focus(), g(c)
      }
    }
    function g(e) {
      'true' !== e.getAttribute('aria-selected') &&
        (e.closest('[role="tablist"]').querySelectorAll('[role="tab"]').forEach(v),
        (function (e) {
          document.querySelector(`#${e.getAttribute('aria-controls')}`).removeAttribute('hidden'), e.setAttribute('aria-selected', !0), e.setAttribute('tabindex', 0)
        })(e))
    }
    function v(e) {
      document.querySelector(`#${e.getAttribute('aria-controls')}`).setAttribute('hidden', !0), e.setAttribute('aria-selected', !1), e.setAttribute('tabindex', -1)
    }
    function y(e) {
      const t = e.cloneNode(!0)
      t.setAttribute('aria-hidden', !0), e.insertAdjacentElement('afterend', t)
    }
    document.querySelectorAll('[data-marquee-item]').forEach(function (e) {
      const t = e.offsetWidth,
        o = e.parentElement.offsetWidth,
        r = Math.ceil(o / t)
      for (let t = 0; t < r; t++) y(e)
    })
    const b = document.getElementById('textarea')
    b &&
      b.addEventListener('input', () => {
        return (e = b), console.log(e.scrollHeight), void (e.style.height = e.scrollHeight + 'px')
        var e
      })
    const w = document.querySelector('.tab-cases__list')
    if (w?.classList.contains('_fixed')) {
      const _ = w.offsetHeight
      w.parentElement.style.setProperty('--tab-list-height', _ / 16 + 'rem')
    }
    gsap.registerPlugin(ScrollTrigger)
    const A = document.querySelector('.cases__content'),
      S = document.querySelector('.cases__side'),
      E = window.matchMedia('(min-width: 47.99875rem)')
    if (A && S && E.matches) {
      function q(e) {
        const t = document.querySelectorAll('.cases__link')
        t.forEach(e => e.classList.remove('_active')), t[e] && t[e].classList.add('_active')
      }
      gsap.to(S, { scrollTrigger: { trigger: S, start: 'top-=145 top', end: '+=' + (A.offsetHeight - S.offsetHeight), pin: !0, pinSpacing: !1 } }),
        document.querySelectorAll('.cases__slider').forEach((e, t) => {
          ScrollTrigger.create({ trigger: e, start: 'top center', end: 'bottom center', onEnter: () => q(t), onEnterBack: () => q(t) })
        })
    }
    f.polyfill()
  })()
})()
;(() => {
  'use strict'
  !(function () {
    function t(t, e) {
      return e === t
    }
    function e(t, e) {
      return t.num < e.num ? -1 : t.num > e.num ? 1 : 0
    }
    let n = []
    function r(e) {
      const n = e.dataset.da.split(','),
        r = n[0].trim(),
        o = n[2] ? (+n[2] ? +n[2].trim() - 1 : n[2].trim()) : 'last',
        i = !!n[3] && n[3].trim(),
        u = i ? e.closest(i).querySelector(n[1].trim()) : document.querySelector(n[1].trim()),
        m = e.parentElement
      let c = Array.from(e.parentElement.children).findIndex(t.bind(null, e))
      return 'next' === o && c++, 'prev' === o && c--, { element: e, media: r, to: u, num: o, parent: i, previous: { to: m, num: c } }
    }
    function o(t) {
      const e = window.matchMedia(`(max-width: ${t.media}px)`)
      e.addListener(i.bind(null, t)), i(t, e, !0)
    }
    function i(t, e, n = !1) {
      const r = t.element
      if (e.matches) {
        const { to: e, position: n } = u(t.to, t.num)
        m(r, e, n)
      } else if (!n) {
        const { to: e, position: n } = u(t.previous.to, t.previous.num)
        m(r, e, n)
      }
    }
    function u(t, e) {
      let n,
        r = t
      return 0 === e || 'first' === e ? (n = 'afterbegin') : e >= t.children.length || 'last' === e ? (n = 'beforeend') : 'next' === e ? (n = 'afterend') : 'prev' === e ? (n = 'beforebegin') : ((r = t.children[e - 1]), (n = 'afterend')), { to: r, position: n }
    }
    function m(t, e, n) {
      t.remove(), e.insertAdjacentElement(n, t)
    }
    !(function () {
      const t = Array.from(document.querySelectorAll('[data-da]'))
      ;(n = t.map(r)), (n = n.sort(e)), n.forEach(o)
    })()
  })()
})()
//# sourceMappingURL=app.min.js.map

window.addEventListener('hashchange', handleHashChange)
handleHashChange()

function handleHashChange() {
  const hash = window.location.hash.substring(1)
  const $styled = document.querySelector('.cases-tab')
  const $tabBtn = hash ? document.querySelector(`#tab-${hash}`) : document.querySelector('[role="tab"]')

  if ($tabBtn) toggle($tabBtn)

  if ($styled) $styled.removeAttribute('style')
}

function toggle($tab) {
  if ($tab.getAttribute('aria-selected') === 'true') return

  const $tabList = $tab.closest('[role="tablist"]')
  const allTabs = $tabList.querySelectorAll('[role="tab"]')

  allTabs.forEach(close)
  open($tab)
}

function close($tab) {
  const $panel = document.querySelector(`#${$tab.getAttribute('aria-controls')}`)

  $panel.setAttribute('hidden', true)

  $tab.setAttribute('aria-selected', false)
  $tab.setAttribute('tabindex', -1)
}

function open($tab) {
  const $panel = document.querySelector(`#${$tab.getAttribute('aria-controls')}`)

  $panel.removeAttribute('hidden')

  $tab.setAttribute('aria-selected', true)
  $tab.setAttribute('tabindex', 0)
}
